import { DEFAULT_TINYMCE_OPTIONS } from '../../../../shared/default-tinymce-options';

export const FOD_START_INBOUND_API_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMce',
    content_css: '/assets/css/fod-default-tinymce.css',

    plugins: [
        'searchreplace',
        'code',
        'link'
    ],

    toolbar1: 'blocks fontsizeinput | searchreplace | charmap subscript superscript | removeformat | code | link',
    toolbar2: 'bold italic underline | forecolor backcolor | bullist numlist | undo redo | visualchars visualblocks | vEDocs',
    //toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',
};
